import { forwardRef, type Ref, type SVGProps } from "react";

function SvgChevronRight(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m6 2.667 3.92 3.919a2 2 0 0 1 0 2.828L6 13.334"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgChevronRight);
export default ForwardRef;
